import { render, staticRenderFns } from "./TransaksiConfirm.vue?vue&type=template&id=6e31ee64"
import script from "./TransaksiConfirm.vue?vue&type=script&lang=js"
export * from "./TransaksiConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports